import { render } from "./TermsOfServiceView.vue?vue&type=template&id=d1d74cce"
const script = {}

import "./TermsOfServiceView.vue?vue&type=style&index=0&id=d1d74cce&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__